// extracted by mini-css-extract-plugin
module.exports = {"suppressOutline":"_40bcbc5a"};